import { Sparkles } from "lucide-react";

interface EditorialCalloutProps {
  title: string;
  description: string;
}

export const EditorialCallout = ({ title, description }: EditorialCalloutProps) => {
  return (
    <div className="my-16 bg-muted/30 border border-border/40 p-8 md:p-12 text-center">
      <div className="flex items-center justify-center gap-3 mb-4">
        <div className="h-px w-12 bg-border" />
        <Sparkles className="h-5 w-5 text-primary" />
        <div className="h-px w-12 bg-border" />
      </div>
      <h3 className="text-2xl md:text-3xl font-bold mb-3 tracking-tight">
        {title}
      </h3>
      <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
        {description}
      </p>
    </div>
  );
};
